import * as types from './mutation-types';

export default {
	[types.STATE_INIT]: state => {
		Object.assign(state, setInitialize());
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	}
};

/**메뉴탭을 닫았다 열었을 때 스토어 초기화 */
function setInitialize() {
	return {
		plants: [],
		useYnList: [],
		gridUseYnList: [],
		searchParams: {
			plantCd: '',
			userGrpName: null,
			userName: null,
			useYn: null
		},
		resultList: [],
		pagingInfo: {
			currentPage: 1,
			endPage: 1,
			pageUnit: 10,
			startPage: 1,
			totalSize: 1
		},
		selectedRow: {
			permGrpCd: '',
			userGrpName: '',
			useYn: ''
		}
	};
}
